export const windowsDevices = require("./windows_overlay-fs8.png");
export const windowsBG = require("./windowsBG02.png");
